// extracted by mini-css-extract-plugin
export default {"deleteConfirmContainer":"deletePopupStyles_deleteConfirmContainer__n9Av+","popupActions":"deletePopupStyles_popupActions__4qr2b"};